import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import styles from './workflowstatus.module.scss';
import { DevelopmentAPI} from 'pages/workspace/process/development/development.service';
import { KoSelect, KoText } from 'packages';
import KoIcon from '@kwapio/icons';

export default function ActivityTypes({ value, onChange }) {
  const { workspaceId } = useParams();
  const [workspaceRecord, setWorkspaceRecord] = useState();

  useEffect(() => {
    if (workspaceId) {
      getWorkspaceById(workspaceId);
    }
  }, [workspaceId]);

  const getWorkspaceById = async(id) => {
    try {
      const data = await DevelopmentAPI.getWorkspaceById(id);
      setWorkspaceRecord(data?.project);
    } catch (err) {
      console.error('Error fetching workspace:', err);
    }
  };

  const activityTypes = workspaceRecord?.template?.ActivityTypes || [];

  const options = activityTypes.map(type => ({
    label: (
      <div className={styles.iconWithLabel} role="img" aria-label={type.label}>
        <KoIcon name={type.icon} style={{ color: type.color, background: type.background }} />
        <KoText text={type.label} />
      </div>
    ),
    value: type.value,
    key: type.value
  }));

  return (
    <KoSelect
      value={value}
      onChange={onChange}
      showSearch
      placeholder='Select issue type'
      options={options}
    />
  );
}
